import {i18n} from 'next-i18next'

function getValidationErrorString({validationErrors}) {
  const keys = Object.keys(validationErrors)
  const texts = []
  for (const key of keys) {
    const code = validationErrors[key]
    if (i18n.t) {
      const text = i18n.t(`errors.${code}`, {label: key, ns: 'deprecated'})
      texts.push(text)
    } else {
      texts.push(`${key}: ${code}`)
    }
  }
  return texts.join(', ')
}

export default function getErrorMessage(message) {
  if (typeof message === 'string') {
    return message
  } else if (message.graphQLErrors) {
    for (const graphError of message.graphQLErrors) {
      if (graphError.error === 'validationError') {
        return getValidationErrorString(graphError)
      } else {
        return graphError.message
      }
    }
  } else if (message.message) {
    return message.message
  } else {
    return message
  }
}
